import { formatPriceForBasket } from "shared/utils/commons";

export default (price: number) =>
  price > 0 ? `+${formatPriceForBasket(price)}` : "";
